import { useEffect, useState } from "react";
import { FormGroup } from "reactstrap";
import CustomDropDown from "../../../Common/FormFields/CustomDropDown";
import { useDispatch, useSelector } from "react-redux";
import {
  addVideoScheduleInformation,
  resetVideoScheduleEventData,
} from "../../../Redux/Actions/VideoScheduleAction";
import AddPlaylistDialog from "../Popups/AddPlaylistDialog";
import { addPlaylistData } from "../../../Redux/Actions/VideoScheduleAction";
import userService from "../../../services/user.service";

const Other = ({ formik }) => {
  const dispatch = useDispatch();
  const videoScheduleInformation = useSelector(
    (state) => state?.videoScheduleInformation
  );
  const schoolId = useSelector((state) => state.loggedInUser.school.id);
  const [open, setOpen] = useState(false);
  const { playlistData, otherEventName } = useSelector(
    (state) => state.videoScheduleInformation
  );
  useEffect(() => {
    addPlaylistData(dispatch, []);
    resetVideoScheduleEventData(dispatch, [
      "otherEventName",
      "uploadPlaylistName",
    ]);
  }, []);
  const eventNameOptions = [
    {
      id: 1,
      name: "Miscellaneous",
    },
    {
      id: 2,
      name: "Clinic",
    },
    {
      id: 3,
      name: "End Of The Season",
    },
  ];

  const togglePlaylistDialog = (status) => {
    setOpen(status);
  };

  const getPlaylistName = (name) => {
    const eventName = eventNameOptions.filter(
      (ele) => ele.name == (name ? name : otherEventName)
    )[0]?.name;

    userService
      .getPlaylistName({
        schoolId,
        eventName,
        seasonType: "Other",
        isPractice: false,
      })
      .then((res) => {
        addPlaylistData(dispatch, []);
        const playlist = res.data.data.content.map((ele) => {
          return { id: ele.id, playlistName: ele.playlistName };
        });
        addPlaylistData(dispatch, playlist);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const createPlaylist = (playlistName) => {
    const eventName = eventNameOptions.filter(
      (ele) => ele.name == otherEventName
    )[0]?.name;

    userService
      .createPlaylist({
        schoolId,
        playlistName,
        eventName,
        isPractice: false,
        seasonType: "Other",
      })
      .then((res) => {
        getPlaylistName();
        togglePlaylistDialog(false);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <>
      <FormGroup>
        <label className="fmlabel mt-6 semi-bold">
          Event Name <span className="redstar">*</span>
        </label>
        <CustomDropDown
          selected={videoScheduleInformation?.otherEventName}
          setSelected={(value) => {
            resetVideoScheduleEventData(dispatch, ["uploadPlaylistName"]);
            addVideoScheduleInformation(dispatch, {
              fieldName: "otherEventName",
              value,
            });
            getPlaylistName(value);
          }}
          formik={formik}
          fieldName="otherEventName"
          defaultSelectOption="Select Event Name"
          options={eventNameOptions}
          fieldToShow="name"
          optionValue="name"
        />
      </FormGroup>
      <FormGroup>
        <label className="fmlabel mt-6 semi-bold">
          Playlist <span className="redstar">*</span>
        </label>
        <CustomDropDown
          selected={videoScheduleInformation?.uploadPlaylistName}
          setSelected={(value) =>
            addVideoScheduleInformation(dispatch, {
              fieldName: "uploadPlaylistName",
              value,
            })
          }
          formik={formik}
          fieldName="playlistName"
          defaultSelectOption="Select Playlist"
          options={playlistData}
          fieldToShow="playlistName"
          optionValue="playlistName"
          isCreatePlaylist={true}
          setOpen={setOpen}
          disabledDropdown={
            videoScheduleInformation?.otherEventName == "" ? true : false
          }
        />
      </FormGroup>
      <AddPlaylistDialog
        successPopUp={open}
        msg="Playlist Name Popup"
        toggleSuccessDialog={togglePlaylistDialog}
        createPlaylist={createPlaylist}
      />
    </>
  );
};

export default Other;
